import { useMutation } from "@apollo/client";
import {
  GET_WISHLIST_DATA,
  REMOVE_PRODUCTS_FROM_WISHLIST,
} from "./wishlist.gql";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";

export const useRemoveFromWishlist = (props = {}) => {
  const { addToast } = useToasts();
  const { wishlistId, itemId } = props;
  const { isSignedIn } = useSelector((state) => state.loginSlice);

  const [removeFromWishlistMutation] = useMutation(
    REMOVE_PRODUCTS_FROM_WISHLIST,
    {
      variables: {
        wishlistId,
        wishlistItemsId: [`${itemId}`],
      },
      onCompleted: () => {
        addToast("Item successfully removed from wishlist", {
          appearance: "success",
          autoDismiss: true,
          style: {
            backgroundColor: "#027B51" /* Custom background color */,
            color: "#fff" /* Custom text color */,
          },
        });
      },
      skip: !isSignedIn,
      refetchQueries: [{ query: GET_WISHLIST_DATA }],
    }
  );

  const removeFromWishlist = async () => {
    try {
      await removeFromWishlistMutation();
    } catch (error) {
      console.error("Error removing from wishlist:", error);
    }
  };

  return {
    removeFromWishlist,
  };
};
